/* eslint-disable react/require-default-props */

/* eslint-disable react/no-array-index-key */

import React from 'react';

import ReportTableContainer from 'reports/Common/ReportTable';
import { convertRebookingReportTypeToTable } from 'reports/utils';

class RebookingTable extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    return (
      this.props.data && (
        <ReportTableContainer
          startDate={this.props.startDate}
          endDate={this.props.endDate}
          title="Rebookings"
          data={{
            rows: convertRebookingReportTypeToTable(this.props.data),
          }}
        />
      )
    );
  }
}

export default RebookingTable;
